import { render, staticRenderFns } from "./messageGroup.vue?vue&type=template&id=28ef26b7&scoped=true&"
import script from "./messageGroup.vue?vue&type=script&lang=js&"
export * from "./messageGroup.vue?vue&type=script&lang=js&"
import style0 from "./messageGroup.vue?vue&type=style&index=0&id=28ef26b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef26b7",
  null
  
)

export default component.exports